<template>
  <div id="maintenance" class="container">
    <div class="row">
      <div class="col-12">
        <h2 v-html="system.header"></h2>
        <p v-html="system.message"></p>
        <p v-html="system.message2"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
  props: {},
  mounted() {
  },
  data: function (){
    return {
    }
  },
  methods: {
  },
  computed: {
    system() {
      return this.$store.getters.getSystem
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
